import Vue from 'vue';
import { getTokenInCookie,setTokenInCookie,removeTokenInCookie } from '@/utils/index'

const unurl = process.env.NODE_ENV == 'production' ? 'http://oa.univ-bio.com' : 'http://oatest.univ-bio.com'
const baseUrl = process.env.NODE_ENV == 'production' ? 'https://oaapi.univ-bio.com/' : 'https://oaapit.univ-bio.com/'

const getDefaultState = () => {
  return {
    token: '',
    userInfo: {},
    userName: '',
    menus:''
  }
}
const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    setTokenInCookie(state.token)
  },
  SET_NAME: (state, name) => {
    state.userName = name
  },
  SET_USERINFO:(state,userInfo)=>{
    state.userInfo = userInfo
  },
  SET_MENUS:(state,menus)=>{
    state.menus = menus
  },
  GETTOKEN:(state)=>{
    state.token = getTokenInCookie()
  }
}

const actions = {
  getToken({ commit, state }) {
    state.token = getTokenInCookie()
    commit('GETTOKEN')
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve,reject) => {
      Vue.prototype.$http({
        url: baseUrl + 'common/getUserInfo',
        method: 'get',
        headers: {
          'token': state.token
        },
      }).then(res => {
        const data = res.data.msg
        if (!data) {
          return reject('验证失败，请重新登录。')
        }
        const name = data.realName
        commit('SET_USERINFO',data)
        commit('SET_NAME',name)
        resolve(data)
      })
    })
  },
  // get user menu
  getMenus({ commit, state }) {
    return new Promise((resolve,reject) => {
      Vue.prototype.$http({
        url: baseUrl + 'common/getOftenNav',
        method: 'get',
        headers: {
          'token': state.token
        },
      }).then(res => {
        const menus = res.data.data
        if (!menus) {
          return reject('验证失败，请重新登录。')
        }
        commit('SET_MENUS',menus)
        resolve(menus)
      })
    })
  },
  // user logout
  logout({ commit, state }) {
    removeTokenInCookie() // must remove  token  first
    commit('RESET_STATE')
    window.location.href = unurl+'/Home/Common/Login/logout'
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeTokenInCookie() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}





// WEBPACK FOOTER //
// ./src/store/modules/user.js